import { Component, ViewChild, OnInit } from '@angular/core';
import { Params } from '@angular/router';
import {
  User,
  Ticket,
  TicketCount,
  ChangeLabelLogData,
  AssignTicketLogData
} from '../../_shared/models';
import {
  TicketService,
  AuthenticationService,
  UserService,
  LoadingService
} from '../../_shared/services';
import { MatTableDataSource, MatSort, Sort } from '@angular/material';
import { Granule } from '../../config';

@Component({
  selector: 'app-ticket-monitoring',
  templateUrl: './ticket-monitoring.component.html',
  styleUrls: [
    '../../../assets/css/core-navbar.css',
    '../_css-ticket/ticket-content.css',
    './ticket-monitoring.component.css',
    './ticket-content-mobile-responsive-monitoring.css'
  ]
})
export class TicketMonitoringComponent implements OnInit {
  public errorMessage: string;
  public successMessage: string;
  private notifErrorModal = false;
  private notifSuccessModal = false;
  private isTicketCountLoaded = false;
  private tickets: Ticket[];
  private alltickets: Ticket[];
  public selectedTicket: Ticket;
  private officers: User[];
  private selectedPage: number = 1;
  private limit = 10;
  private filterDropdown = 'Open';
  private statusClass = [
    'nav-item',
    'nav-item',
    'nav-item',
    'nav-item',
    'nav-item',
    'nav-item'
  ];
  private filterOptions = [
    'All',
    'Open',
    'Replied',
    'Taken',
    'Solved',
    'Closed'
  ];
  private user: User;
  private ticketCount: TicketCount;
  private storageProfileUrl = this.granule.CMS_ROUTE_STORAGE_USER;
  private storageTicketUrl = this.granule.CMS_ROUTE_STORAGE_TICKET;
  private toggleDropdown: Array<boolean> = new Array<boolean>(4);
  /**
   * 0 = Label
   * 1 = Member
   * 2 = Page
   * 3 = select status option for mobile layout
   */

  constructor(
    private ticketService: TicketService,
    private userService: UserService,
    private loadingService: LoadingService,
    private authenticationService: AuthenticationService,
    private granule: Granule
  ) {
    this.load(false);
  }

  ngOnInit() {
    this.user = this.authenticationService.getUserInfo();
    this.getMonitoredTickets();
    this.initToggleDropdown();
    this.statusClass[1] = 'nav-item active';
  }

  ngOnChanges(changes: any) {
    if (changes['alltickets']) {
      this.tickets = this.alltickets.filter(
        h => h.status == this.filterDropdown
      );
    }
  }

  sortData(sort: Sort) {
    const data = this.tickets.slice();
    if (!sort.active || sort.direction == '') {
      this.tickets = data;
      return;
    }

    this.tickets = data.sort((a, b) => {
      let isAsc = sort.direction == 'asc';
      switch (sort.active) {
        case 'number':
          return this.compare(a.ticket_id, b.ticket_id, isAsc);
        case 'subject':
          return this.compare(
            a.subject.toLowerCase(),
            b.subject.toLowerCase(),
            isAsc
          );
        case 'createdBy':
          /**
           * Always put the null user (deleted user) on the end of list
           *
           * A = null, B = some user
           * return 1 so it will turn out as B,A
           *
           * C = some user, D = null
           * return -1 so it will turn out C,D
           */
          if (!a.cust_detail) {
            return 1;
          } else if (!b.cust_detail) {
            return -1;
          } else {
            return this.compare(
              a.cust_detail.fullname.toLowerCase(),
              b.cust_detail.fullname.toLowerCase(),
              isAsc
            );
          }
        case 'createdOn':
          return this.compare(a.created_at, b.created_at, isAsc);
        case 'takeBy':
          if (!a.taken_by && !b.taken_by) {
            return this.compare(a.ticket_id, b.ticket_id, isAsc);
          } else if (!a.officer_detail) {
            return 1;
          } else if (!b.officer_detail) {
            return -1;
          } else {
            return this.compare(
              a.officer_detail.fullname.toLowerCase(),
              b.officer_detail.fullname.toLowerCase(),
              isAsc
            );
          }
        case 'label':
          return this.compare(a.label, b.label, isAsc);
        default:
          return 0;
      }
    });
  }

  compare(a: any, b: any, isAsc: any) {
    return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
  }

  assignTo(officer: User) {
    // force assign a ticket to a staff
    this.selectedTicket.officer_detail = officer;
  }

  changeDivision(value: any) {
    let updatedata = {
      division: this.selectedTicket.division,
      ticketid: this.selectedTicket.ticket_id,
      status: 'Open',
      type: 'Technical',
      Log: {
        setdivision_by: localStorage.getItem('uid'),
        division: this.selectedTicket.division
      }
    };
    // add ticket service to change division
  }

  changeLabel(label: number) {
    this.selectedTicket.label = label;
  }

  changeLimit(value: number) {
    this.limit = value;
  }

  changePage(value: number) {
    this.selectedPage = value;
  }

  clearTicket() {
    this.selectedTicket = null;
  }

  closeNotifModal() {
    this.notifErrorModal = false;
    this.notifSuccessModal = false;
    this.errorMessage = null;
  }

  dropdownControl(value: number) {
    for (let i = 0; i < 4; i++) {
      if (i === value) {
        // if the array number match with value from function, reverse the bool value to toggle
        this.toggleDropdown[i] = !this.toggleDropdown[i];
      } else {
        // other than that, set to false to close dropdown
        this.toggleDropdown[i] = false;
      }
    }
  }

  getMonitoredTickets() {
    this.ticketService
      .getMonitoredTickets(
        this.user.current_role.division_id,
        this.selectedPage
      )
      .subscribe(
        res => {
          this.tickets = res.data;
          this.alltickets = res.data;
        },
        x => {
          console.log('ERROR: ' + x);
        },
        () => {
          // get users data after loading tickets
          this.getUsers();
          this.filterStatus('Open', 1);
          this.load(false);
        }
      );
  }

  getUsers() {
    this.userService.getUsers('distribution').subscribe(
      res => {
        this.officers = res.data;
      },
      x => {
        console.log('ERROR: ' + x);
      },
      () => {}
    );
  }

  getTicketCount(user_role: string, ticket: Ticket) {
    this.selectedTicket = ticket;
    this.isTicketCountLoaded = false;
    if (this.selectedTicket.cust_detail === null) return;
    setTimeout(() => {
      let payload = JSON.stringify({
        user_id: this.selectedTicket.cust_detail._id,
        user_role: user_role
      });
      this.userService.getCountedTickets(payload).subscribe(res => {
        this.ticketCount = res.data;
        this.isTicketCountLoaded = true;
      });
    }, 50);
  }

  initToggleDropdown() {
    // init the dropdown for the first time, and also closes the dropdown if called
    for (let i in this.toggleDropdown) {
      this.toggleDropdown[parseInt(i)] = false;
    }
  }

  load(value: boolean) {
    this.loadingService.setLoadingState(value);
  }

  selectTicket(ticket: any) {
    this.selectedTicket = ticket;
    this.initToggleDropdown();
  }

  filterStatus(value: any, i: number) {
    for (let index in this.statusClass) {
      this.statusClass[parseInt(index)] = 'nav-item';
    }
    this.statusClass[i] = 'nav-item active';

    if (value == 'All') {
      this.tickets = this.alltickets;
    } else if (value == 'Open') {
      this.tickets = this.alltickets.filter(ticket => ticket.taken_by == null);
    } else if (value == 'Taken') {
      this.tickets = this.alltickets.filter(ticket => ticket.taken_by != null);
    } else {
      this.tickets = this.alltickets.filter(ticket => ticket.status == value);
    }
  }

  dropdownSortBy(value: any, i: number) {
    this.filterDropdown = value;
    this.filterStatus(value, i);
  }

  onSubmit() {
    let update_assigndata: AssignTicketLogData = {
      Log: {
        assigned_to: this.selectedTicket.officer_detail._id,
        assigned_by: this.user._id
      },
      status: 'Open',
      ticket_id: this.selectedTicket.ticket_id
    };

    this.ticketService.setLabelAndAssign(update_assigndata).subscribe(
      res => {
        this.selectedTicket.taken_by = res.data.taken_by;
      },
      x => {
        console.log('ERROR: ' + x);
      },
      () => {}
    );

    let update_labeldata: ChangeLabelLogData = {
      Log: {
        label_value: this.selectedTicket.label,
        labelled_by: this.user._id
      },
      status: 'Open',
      ticket_id: this.selectedTicket.ticket_id
    };

    this.ticketService.setLabelAndAssign(update_labeldata).subscribe(
      res => {
        this.selectedTicket.label = res.data.label;
      },
      x => {},
      () => {}
    );
  }

  displayedColumns = ['id', 'subject', 'createdBy', 'createdOn'];
  dataSource = new MatTableDataSource(this.tickets);

  @ViewChild(MatSort) sort: MatSort;

  /**
   * Set the sort after the view init since this component will
   * be able to query its view for the initialized sort.
   */
  ngAfterViewInit() {
    this.dataSource.sort = this.sort;
  }
}

@Component({
  selector: 'mat-spinner',
  templateUrl: 'ticket-monitoring.component.html'
})
export class LoadingSpinnerMonitoring {}



// WEBPACK FOOTER //
// D:/Work-Local/frontend/src/app/ticket/ticket-monitoring/ticket-monitoring.component.ts